import type { UserStatusesFetchedAction } from '@Application/Users/UserStatuses/Actions/userStatusesFetched';
import type { UserRevokedAction } from '@Application/Security/Authentications/Actions/userRevoked';
import LabeledValueView from '@UI/Store/Shared/Views/LabeledValueView';
import { createSliceReducer, registerStore } from '@verclam/synapse';

export type UserStatusesStore = {
	userStatuses: readonly LabeledValueView[] | null;
};

const initialState: UserStatusesStore = {
	userStatuses: null,
};

type Actions = UserStatusesFetchedAction | UserRevokedAction;

const whenUserStatusesFetched = (
	store: UserStatusesStore,
	action: UserStatusesFetchedAction,
): UserStatusesStore => ({
	...store,
	userStatuses: action.payload.map((entry) => new LabeledValueView(entry)),
});

// A catalog of labels has no reason to survive a session: the next session refetches it.
const whenUserRevoked = (): UserStatusesStore => initialState;

export default registerStore<'userStatusesStore', Actions>(
	'userStatusesStore',
	createSliceReducer({
		USER_STATUSES_FETCHED: whenUserStatusesFetched,
		USER_REVOKED: whenUserRevoked,
	}),
	initialState,
);
